import { Box, Button, Card, CardBody, CardFooter, Heading, Image, Markdown, Page, PageContent, Paragraph } from "grommet"
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom"
import { AmbientFrogs } from "../components/homepage/ambient-frogs/AmbientFrogs";

export const HomePage = () => {

    const navigate = useNavigate();
    const { t, ready } = useTranslation('homepage', { useSuspense: false });

    if (ready) {
        return (
            <Page kind="wide">
                <AmbientFrogs />
                <PageContent>
                    <Box margin={{ top: 'large' }} align="center">
                        {/* <Heading style={{ maxWidth: '700px', lineHeight: '60px' }} textAlign="center" fill weight={'bolder'} overflowWrap="break-word">{`What You Wish? Обираєш ти!`}</Heading> */}
                        <Heading style={{ maxWidth: '800px', lineHeight: '60px' }} textAlign="center" fill weight={'bolder'} overflowWrap="break-word">{t('mainHeader')}</Heading>
                    </Box>
                    <Box align="center">
                        <Heading level={3} style={{ lineHeight: '36px' }} textAlign="center" fill>{t('secondHeader')}</Heading>
                    </Box>
                    <Box margin={{ top: 'medium', bottom: 'large' }} align="center">
                        <Button primary label={t('getStartedBtn')} onClick={() => navigate('/settings/overlay-settings')} />
                    </Box>
                <Box gap="medium" margin={{ bottom: 'medium' }}>
                        <Box direction="row" gap="medium" style={{ maxHeight: '300px' }} data-frog-anchor="auction">
                            <Card basis="1/3">
                                <CardBody pad={'none'}>
                                    <Image fit="cover" src={`${process.env.REACT_APP_CDN_BASE_URL}/homepage/auc_banner.webp`} />
                                </CardBody>
                            </Card>
                            <Card basis="2/3" data-frog-streamer-anchor="auction">
                                <CardBody>
                                    <Heading level={3} margin={'none'} weight={'bold'}>{t('auctionTitle')}</Heading>
                                    <Paragraph maxLines={5} responsive fill margin={{ top: 'medium', bottom: 'none' }}>
                                        {/* A simple tool for giveaways that makes your stream interactive and fun. Connect donate platforms or Twitch to receive requests from viewers. 
                                        The Wheel of Random will choose the winner. Different spin modes - simple and dropout. */}
                                        {t('auctionDescription')}
                                    </Paragraph>
                                </CardBody>
                                <CardFooter justify="end" pad={{ top: 'none', bottom: 'medium', left: 'medium', right: 'medium' }}>
                                    <Button primary label={t('tryNowBtn')} onClick={() => navigate('/auction')} />
                                </CardFooter>
                            </Card>
                        </Box>
                        <Box direction="row" gap="medium" style={{ maxHeight: '300px' }} data-frog-anchor="roulette">
                            <Card basis="2/3" data-frog-streamer-anchor="roulette">
                                <CardBody>
                                    <Heading level={3} margin={'none'} weight={'bold'}>{t('rouletteTitle')}</Heading>
                                    <Paragraph maxLines={5} responsive fill margin={{ top: 'medium', bottom: 'none' }}>
                                        {/* Customiziable roulette widget for stream. Create your rewards or tasks to add entertainmant to your stream or reward the viewers. */}
                                        {t('rouletteDescription')}
                                    </Paragraph>
                                </CardBody>
                                <CardFooter justify="end" pad={{ top: 'none', bottom: 'medium', left: 'medium', right: 'medium' }}>
                                    <Button primary label={t('tryNowBtn')} onClick={() => navigate('/dashboard/roulette')} />
                                </CardFooter>
                            </Card>
                            <Card basis="1/3">
                                <CardBody pad={'none'}>
                                    <Image fit="cover" src={`${process.env.REACT_APP_CDN_BASE_URL}/homepage/roulette_banner.webp`} />
                                </CardBody>
                            </Card>
                        </Box>
                        <Box direction="row" gap="medium" style={{ maxHeight: '300px' }}>
                            <Card basis="1/3">
                                <CardBody pad={'none'}>
                                    <Image fit="cover" src={`${process.env.REACT_APP_CDN_BASE_URL}/homepage/memes_banner.webp`} />
                                </CardBody>
                            </Card>
                            <Card basis="2/3" data-frog-streamer-anchor="memes">
                                <CardBody>
                                    <Heading level={3} margin={'none'} weight={'bold'}>{t('memesTitle')}</Heading>
                                    <Box flex={'grow'}>
                                        <Paragraph maxLines={5} responsive fill margin={{ top: 'medium', bottom: 'none' }}>
                                            {/* Overlay Memes that will make your broadcasts more entertaining and enjoyable. */}
                                            {t('memesDescription')}
                                        </Paragraph>
                                    </Box>
                                    <Box flex={'grow'}>
                                        <Markdown>{t('memesBulletList')}</Markdown>
                                    </Box>
                                </CardBody>
                                <CardFooter justify="end" pad={{ top: 'none', bottom: 'medium', left: 'medium', right: 'medium' }}>
                                    <Button primary label={t('tryNowBtn')} onClick={() => navigate('/memes')} />
                                </CardFooter>
                            </Card>
                        </Box>
                </Box>
                </PageContent>
            </Page>
        )
    }
}
